import { AttachmentCheckIcon } from './AttachmentCheckIcon';

/**
 * author: Colton Wiscombe
 * id 8B6BEB96-8C6B-4271-B87F-A568DF587900
 * name attachment-check
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/attachment-check.svg
 * tags
 */
export const PaperclipTickIcon = AttachmentCheckIcon;
export default PaperclipTickIcon